import React, { useContext } from 'react';
import { FaPlus } from 'react-icons/fa';
import { BASE_URL } from '../../../../BaseUrl';
import { currencySymbolLeft, getSystemSettings } from '../../../../functions/Functions';
import { SettingsContext } from '../../../../contexts/Settings';

const PopularItemCard = ({ item, onClick, isOrderPunchingEnabled, isSidebar = false, showImage = true }) => {
  const { generalSettings } = useContext(SettingsContext);

  const handleDisable = (foodItem) => {
    const isDisabled = !!((generalSettings &&
      parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 &&
      (foodItem?.available_qty <= 0 || foodItem?.available_qty === undefined) &&
      foodItem?.is_deal === 0 && !foodItem?.is_recipe));
    return isDisabled;
  };

  const Isshowtags = (foodItem) => {
    return (
      generalSettings &&
      parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 &&
      foodItem?.is_deal === 0 &&
      !foodItem?.is_recipe
    );
  };

  const renderStockQty = (foodItem) => {
    if (!foodItem) return null;

    if (foodItem?.available_qty <= 0 || foodItem?.available_qty === undefined) {
      return (
        <span className="modern-tag out-of-stock">Out of stock</span>
      );
    } 
  };

  const disabled = handleDisable(item);

  // The image-hidden class switches this card to a compact text-only layout.
  return (
    <div 
      className={`popular-item-card flex-shrink-0 ${disabled ? "disabled" : ""} ${isSidebar ? "sidebar-card" : "main-card"} ${showImage ? "" : "image-hidden"}`}
      onClick={() => { if (!disabled) onClick(item); }}
    >
      {showImage && <img
        src={item.image ? BASE_URL + item.image : "/assets/img/default-item.jpeg"} 
        alt={item.name}
        className="popular-item-img"
        loading="lazy"
        onError={(e) => { e.target.onerror = null; e.target.src = "/assets/img/default-item.jpeg" }}
      />}
      
      {showImage && <div className="popular-item-overlay"></div>}

      {Isshowtags(item) && (
        <div className="modern-tag-overlay">
          {renderStockQty(item)}
        </div>
      )}

      <div className={`popular-item-content ${showImage ? "" : "image-hidden-content"}`}>
        <h6 className="mb-0 text-white fw-bold popular-item-title">{item.name}</h6>
        {item.price && (
          <div className="popular-item-price fw-semibold mt-1">
            {currencySymbolLeft()} {item.price}
          </div>
        )}
      </div>

      {isOrderPunchingEnabled && !disabled && (
        <button 
          className="btn rounded-circle position-absolute d-flex align-items-center justify-content-center shadow-sm popular-add-btn"
          onClick={(e) => { e.stopPropagation(); onClick(item); }}
        >
          <FaPlus />
        </button>
      )}
    </div>
  );
};

export default PopularItemCard;
